export default __webpack_public_path__ + "media/images/front/policy/hero_lg-6c69a56163dca0098d86767329accf76.jpg";